import { isArrayValue } from "@smartsuite/fields-logic/lib/safe-field-value/type-checking/arrays";

/**
 * Coerces a form value into the array shape a "multiple entries" control expects.
 *
 * Only the control knows whether it renders the single or the multiple variant of its field type
 * (`entries_allowed` decides, and both variants share one slug), so this is the layer that has to
 * normalize. A restored localStorage checkpoint, a URL prefill or an internal-form record can hold
 * the scalar shape written while the field was still single-valued; rendering that scalar threw
 * `.map is not a function` (FORMS-WEB-XG, FORMS-WEB-X1).
 */
export const toMultipleValue = <TValue>(value: unknown): TValue[] => {
  if (isArrayValue(value)) {
    return value as TValue[];
  }

  if (value === null || value === undefined || value === "") {
    return [];
  }

  return [value as TValue];
};
